import { createContext, useContext } from "react";
export const UndoContext = createContext<(label: string) => void>(() => undefined);
export const useUndo = () => useContext(UndoContext);
export function UndoToast({ label, undo }: { label: string; undo: () => void }) {
  return <div className="undo-toast" role="status">{label} 지웠어요 <button type="button" className="button" onClick={undo}>되돌리기</button></div>;
}
